import { render, staticRenderFns } from "./PostsSelectionBoxes.vue?vue&type=template&id=05d84bb1&"
import script from "./PostsSelectionBoxes.vue?vue&type=script&lang=js&"
export * from "./PostsSelectionBoxes.vue?vue&type=script&lang=js&"
import style0 from "./PostsSelectionBoxes.vue?vue&type=style&index=0&id=05d84bb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports